import { createSelector } from '@reduxjs/toolkit';

//📌 Selector for get all permissions from current profile
export const selectPermissions = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID],
	(permissionsData, orgID) => permissionsData[orgID] || []
);

//📌 Selector for people permissions by organization
export const selectPeoplePermissions = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID],
	(permissionsData, orgID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		return permissionsForOrg.people || [];
	}
);

//📌 Selector for teams permissions by organization
export const selectTeamPermissions = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID],
	(permissionsData, orgID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		return permissionsForOrg.teams || [];
	}
);

//📌 Selector for devices permissions by organization
export const selectDevicePermissions = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID],
	(permissionsData, orgID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		return permissionsForOrg.devices || [];
	}
);

//📌 Selector for devices permissions scoped to one deviceID only
export const selectPermissionsByDeviceID = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID, (_, deviceID) => deviceID],
	(permissionsData, orgID, deviceID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		const allDevicePermissions = permissionsForOrg.devices || [];
		return allDevicePermissions.filter((perm) => perm.deviceID === deviceID);
	}
);

//📌 Selector for device groups permissions by organization
export const selectDeviceGroupPermissions = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID],
	(permissionsData, orgID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		return permissionsForOrg.groups || [];
	}
);

//📌 Selector for device groups permissions scoped to one groupID only
export const selectPermissionsByGroupID = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID, (_, groupID) => groupID],
	(permissionsData, orgID, groupID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		const allGroupPermissions = permissionsForOrg.groups || [];
		return allGroupPermissions.filter((perm) => perm.assetGroupID === groupID);
	}
);

// 📌 Selector for people permissions scoped to one personID only
export const selectPermissionsByPersonID = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID, (_, personID) => personID],
	(permissionsData, orgID, personID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		const allPeoplePermissions = permissionsForOrg.people || [];
		return allPeoplePermissions.filter((perm) => perm.personID === personID);
	}
);

//📌 Selector for teams permissions scoped to one teamID only
export const selectPermissionsByTeamID = createSelector(
	[(state) => state.Permissions.data, (state) => state.Auth.selectedProfile.orgID, (_, teamID) => teamID],
	(permissionsData, orgID, teamID) => {
		const permissionsForOrg = permissionsData[orgID] || {};
		const allTeamPermissions = permissionsForOrg.teams || [];
		return allTeamPermissions.filter((perm) => perm.teamID === teamID);
	}
);
